import React, { useContext } from 'react';
import styled from 'styled-components';
import { Badge, Dropdown, Thumbnail } from '@bynder/design-system';

import { IconUser } from '@bynder/icons';
import { InfoContext } from '../../context';
import { useUserMenuItems } from './useUserMenuItems';
import { OutOfOfficeModal } from '../OutOfOffice/OutOfOfficeModal';
import { LiWithFocusHighlight } from '../CommonStyles';
import { useImageValidation } from '../../helpers/useImageValidation';
import { BREAKPOINTS } from '../../breakpoints';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm: 71
 */
export function UserMenu() {
	const { general } = useContext(InfoContext);
	const menuItems = useUserMenuItems();
	const isImageValid = useImageValidation(general.userPictureUrl);

	const anchorStyles = {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	};

	const shouldShowImage = general.userPictureUrl && isImageValid;

	return (
		<>
			<OutOfOfficeModal />
			<Dropdown
				trigger={({ isOpen, ...triggerProps }) => (
					<LiWithFocusHighlight
						className={`touch-block ${isOpen ? 'hover' : ''}`}
						{...triggerProps}
					>
						<a
							href="#"
							onClick={(e) => e.preventDefault()} // to prevent it from replacing whatever # is in the href
							title={general.userName}
							className="admin-dropdown profile"
							style={anchorStyles}
						>
							{shouldShowImage ? (
								<Thumbnail
									variant="content"
									size="s"
									shape="circle"
									imageUrl={general.userPictureUrl ?? ''}
								/>
							) : (
								<Thumbnail
									variant="clean"
									icon={<IconUser />}
									size="xs"
									shape="circle"
								/>
							)}
							<Username>{general.userName}</Username>
						</a>
					</LiWithFocusHighlight>
				)}
				minWidth="240px"
				noMaxHeight
			>
				{menuItems.map((item) => {
					if (!item.isVisible) {
						return null;
					}

					if (item.Component) {
						const Component = item.Component;

						return <Component key={item.key} />;
					}

					const Icon = item.icon;

					return (
						<Dropdown.Item
							href={item.href || ''}
							icon={Icon ? <Icon /> : undefined}
							badge={
								item.badgeLabel ? (
									<Badge isPillShaped>{item.badgeLabel}</Badge>
								) : undefined
							}
							key={item.key}
						>
							{item.label}
						</Dropdown.Item>
					);
				})}
			</Dropdown>
		</>
	);
}

const Username = styled.span`
	@media (max-width: ${BREAKPOINTS.TABLET}px) {
		display: none;
	}
`;
